import React from 'react';
import { IconProps } from './types/Icon.type';

const Search28Icon = (props: IconProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6 20.3C16.8526 20.3 20.3 16.8526 20.3 12.6C20.3 8.34741 16.8526 4.9 12.6 4.9C8.34741 4.9 4.9 8.34741 4.9 12.6C4.9 16.8526 8.34741 20.3 12.6 20.3ZM12.6 21.7C17.6258 21.7 21.7 17.6258 21.7 12.6C21.7 7.57421 17.6258 3.5 12.6 3.5C7.57421 3.5 3.5 7.57421 3.5 12.6C3.5 17.6258 7.57421 21.7 12.6 21.7Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0955 18.1134C18.369 17.8402 18.8122 17.8404 19.0855 18.1139L24.2952 23.3288C24.5685 23.6023 24.5682 24.0455 24.2947 24.3187C24.0212 24.592 23.578 24.5918 23.3048 24.3182L18.095 19.1033C17.8218 18.8298 17.822 18.3866 18.0955 18.1134Z"
        fill="#121212"
      />
    </svg>
  );
};

export default Search28Icon;
